import React from "react"

import * as styles from "./index.module.scss"

type Props = {
  percentage: number
}

function ProgressBar({ percentage }: Props) {
  return (
    <div className={styles.container}>
      <div
        data-testid="ProgressBarInternal"
        className={styles.bar}
        style={{ width: `${percentage}%` }}
      />
    </div>
  )
}

export default ProgressBar
